import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { ProtectedRoute, FullPageLoader } from '@/router/ProtectedRoute'
import { useYoneticiErisimi } from '@/hooks/useYetki'
import { LoginPage } from '@/pages/login/LoginPage'
import { KurulumPage } from '@/pages/kurulum/KurulumPage'
import { BossLayout } from '@/components/layout/BossLayout'
import { BossOverview } from '@/pages/boss/BossOverview'
import { SubelerPage } from '@/pages/boss/subeler/SubelerPage'
import { PozisyonlarPage } from '@/pages/boss/pozisyonlar/PozisyonlarPage'
import { PersonelPage } from '@/pages/boss/personel/PersonelPage'
import { VardiyalarPage } from '@/pages/boss/vardiyalar/VardiyalarPage'
import { GorevlerPage } from '@/pages/boss/gorevler/GorevlerPage'
import { PuantajlarPage } from '@/pages/boss/puantaj/PuantajlarPage'
import { AvanslarPage } from '@/pages/boss/avans/AvanslarPage'
import { IzinlerPage } from '@/pages/boss/izinler/IzinlerPage'
import { ResmiTatillerPage } from '@/pages/boss/tatiller/ResmiTatillerPage'
import { DogumGunleriPage } from '@/pages/boss/dogumgunleri/DogumGunleriPage'
import { MaliyetPage } from '@/pages/boss/maliyet/MaliyetPage'
import { MaaslarPage } from '@/pages/boss/maaslar/MaaslarPage'
import { LoglarPage } from '@/pages/boss/loglar/LoglarPage'
import { AyarlarPage } from '@/pages/boss/ayarlar/AyarlarPage'
import { YoneticiLayout } from '@/components/layout/YoneticiLayout'
import { YoneticiOverview } from '@/pages/yonetici/YoneticiOverview'
import { YoneticiPersonelPage } from '@/pages/yonetici/personel/YoneticiPersonelPage'
import { YoneticiVardiyalarPage } from '@/pages/yonetici/vardiyalar/YoneticiVardiyalarPage'
import { YoneticiMolalarPage } from '@/pages/yonetici/molalar/YoneticiMolalarPage'
import { YoneticiMaliyetPage } from '@/pages/yonetici/maliyet/YoneticiMaliyetPage'
import { GirisCikisPage } from '@/pages/ortak/GirisCikisPage'
import { PersonelDashboard } from '@/pages/personel/PersonelDashboard'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/giris" element={<LoginPage />} />
        <Route path="/kurulum" element={<KurulumPage />} />

        <Route
          path="/boss"
          element={
            <ProtectedRoute izinliRoller={['boss']}>
              <BossLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<BossOverview />} />
          <Route path="subeler" element={<SubelerPage />} />
          <Route path="pozisyonlar" element={<PozisyonlarPage />} />
          <Route path="personel" element={<PersonelPage />} />
          <Route path="vardiyalar" element={<VardiyalarPage />} />
          <Route path="gorevler" element={<GorevlerPage />} />
          <Route path="puantajlar" element={<PuantajlarPage />} />
          <Route path="avanslar" element={<AvanslarPage />} />
          <Route path="izinler" element={<IzinlerPage />} />
          <Route path="tatiller" element={<ResmiTatillerPage />} />
          <Route path="dogumgunleri" element={<DogumGunleriPage />} />
          <Route path="maliyet" element={<MaliyetPage />} />
          <Route path="maaslar" element={<MaaslarPage />} />
          <Route path="loglar" element={<LoglarPage />} />
          <Route path="giris-cikis" element={<GirisCikisPage />} />
          <Route path="ayarlar" element={<AyarlarPage />} />
        </Route>

        <Route
          path="/yonetici"
          element={
            <ProtectedRoute yoneticiErisimi>
              <YoneticiLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<YoneticiOverview />} />
          <Route path="personel" element={<YoneticiPersonelPage />} />
          <Route path="vardiyalar" element={<YoneticiVardiyalarPage />} />
          <Route path="gorevler" element={<GorevlerPage />} />
          <Route path="molalar" element={<YoneticiMolalarPage />} />
          <Route path="puantaj" element={<PuantajlarPage />} />
          <Route path="avanslar" element={<AvanslarPage />} />
          <Route path="maaslar" element={<MaaslarPage />} />
          <Route path="maliyet" element={<YoneticiMaliyetPage />} />
          <Route path="giris-cikis" element={<GirisCikisPage />} />
        </Route>

        {/* Eski yönlendirmeler — geçici, yetki sistemine geçiş */}
        <Route path="/sorumlu/*" element={<Navigate to="/yonetici" replace />} />
        <Route path="/muhasebe/*" element={<Navigate to="/yonetici" replace />} />

        <Route
          path="/personel/*"
          element={
            <ProtectedRoute izinliRoller={['personel']}>
              <PersonelDashboard />
            </ProtectedRoute>
          }
        />

        <Route path="/yetkisiz" element={<YetkisizPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

function RootRedirect() {
  const { firebaseUser, kullanici, yukleniyor } = useAuth()
  const yonetici = useYoneticiErisimi()
  if (yukleniyor) return <FullPageLoader />
  if (!firebaseUser || !kullanici) return <Navigate to="/giris" replace />

  if (kullanici.rol === 'boss') return <Navigate to="/boss" replace />
  if (yonetici) return <Navigate to="/yonetici" replace />
  if (kullanici.rol === 'personel') return <Navigate to="/personel" replace />
  return <Navigate to="/yetkisiz" replace />
}

function YetkisizPage() {
  const { cikisYap } = useAuth()
  return (
    <div className="page-container flex items-center justify-center bg-gray-50">
      <div className="card max-w-md text-center">
        <h1 className="text-xl font-bold mb-4">Yetkisiz Erişim</h1>
        <p className="text-gray-600 mb-6">
          Bu sayfaya erişim yetkiniz yok veya hesabınız pasif durumda.
        </p>
        <button onClick={cikisYap} className="btn-primary w-full">
          Çıkış Yap
        </button>
      </div>
    </div>
  )
}

export default App
